import { Backend, OrderByDirection } from '@freelancer/datastore/core';
import { UserNotificationPreferencesCollection } from './user-notification-preferences.types';

const API_ENDPOINT = 'user/settings/notifications.php';

export function userNotificationPreferencesBackend(): Backend<UserNotificationPreferencesCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: () => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
    }),
    push: undefined,
    set: undefined,
    update: (_, settings) => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
      method: 'PUT',
      payload: {
        announcement: settings.announcement,
        bid_private_message: settings.bidPrivateMessage,
        bid_update_frequency: settings.bidUpdateFrequency,
        bid_update: settings.bidUpdate,
        community_digest: settings.communityDigest,
        contacts_request: settings.contactsRequest,
        contest_entry: settings.contestEntry,
        contest_private_message: settings.contestPrivateMessage,
        contest_top_contest: settings.contestTopContest,
        deals: settings.deals,
        email_format: settings.emailFormat,
        group_comment: settings.groupComment,
        group_post: settings.groupPost,
        latest_projects_contests_frequency:
          settings.latestProjectsContestsFrequency,
        latest_projects_contests: settings.latestProjectsContests,
        local_project_transactionals: settings.localProjectTransactionals,
        local_projects_sms: settings.localProjectsSms,
        marketing: settings.marketing,
        marketplace: settings.marketplace,
        milestone_release: settings.milestoneRelease,
        nearby_local_projects: settings.nearbyLocalProjects,
        newsletter: settings.newsletter,
        private_message_from_contact: settings.privateMessageFromContact,
        private_message: settings.privateMessage,
        project_awarded: settings.projectAwarded,
        project_contest_message: settings.projectContestMessage,
        receive_sms: settings.receiveSms,
        recommend_top_freelancer: settings.recommendTopFreelancer,
        recruiter_contact: settings.recruiterContact,
        referral: settings.referral,
        services: settings.services,
        sites: settings.sites,
        staff_message: settings.staffMessage,
      },
    }),
    remove: undefined,
  };
}
